import clsx from "clsx";
import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react";

interface CommonProps {
  label: string;
  error?: string;
}

interface InputProps extends CommonProps {
  kind?: "input";
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

interface TextareaProps extends CommonProps {
  kind: "textarea";
  textareaProps?: TextareaHTMLAttributes<HTMLTextAreaElement>;
}

type Props = InputProps | TextareaProps;

export const InputField = (props: Props): JSX.Element => {
  return (
    <label className="block">
      <span className="mb-1 block text-[13px] text-[var(--text-secondary)]">{props.label}</span>
      {props.kind === "textarea" ? (
        <textarea
          {...props.textareaProps}
          className={clsx("input min-h-[120px] py-3", props.error && "error", props.textareaProps?.className)}
        />
      ) : (
        <input {...props.inputProps} className={clsx("input", props.error && "error", props.inputProps?.className)} />
      )}
      {props.error ? <span className="mt-1 block text-xs text-[var(--status-blocker)]">{props.error}</span> : null}
    </label>
  );
};
